'use strict';

var AddConversationIdToHeaderFactory = function AddConversationIdToHeaderFactory() {
  var timestamp = Date.now();
  return {
    request: function request(config) {
      config.headers.conversation_id = 'UI_' + timestamp;
      return config;
    }
  };
};
AddConversationIdToHeaderFactory.$inject = [];
module.exports = AddConversationIdToHeaderFactory;